import ApiService from './ApiService'
import { buildURL } from 'utils/buildUrl'

const endpoint = '/treatments'

export async function apiCreateTreatements(data) {
    return ApiService.fetchData({
        url: `${endpoint}`,
        method: 'post',
        data,
    })
}

export async function apiEditTreatement(data, id) {
    return ApiService.fetchData({
        url: `${endpoint}/${id}`,
        method: 'patch',
        data,
    })
}

export async function apiGetTreatements(queryParams = {}) {
    const { filterData, ...rest } = queryParams
    const flatParams = {
        ...rest,
        ...(filterData?.category && { category: filterData.category }),
    }

    const queryString = Object.entries(flatParams)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&')
    // Add the query string to the URL if it's not empty
    const url = queryString ? `${endpoint}?${queryString}` : endpoint
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetAssistants(queryParams = {}) {
    const url = buildURL(`${endpoint}/assistants-list?`, [], queryParams)

    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetTreatement(data) {
    return ApiService.fetchData({
        url: `${endpoint}/${data}`,
        method: 'get',
        data,
    })
}

export async function apiDeleteTreatement(data) {
    return ApiService.fetchData({
        url: `${endpoint}/${data}`,
        method: 'delete',
        data,
    })
}

// ============== TREATMENT CATEGORIES ==============

const categoriesEndpoint = `${endpoint}/categories`

export async function apiGetTreatmentCategories(queryParams = {}) {
    const params = {}
    if (queryParams.includeInactive) {
        params.includeInactive = 'true'
    }
    const url = buildURL(categoriesEndpoint, [], params)
    return ApiService.fetchData({
        url,
        method: 'get',
    })
}

export async function apiCreateTreatmentCategory(data) {
    return ApiService.fetchData({
        url: categoriesEndpoint,
        method: 'post',
        data,
    })
}

export async function apiEditTreatmentCategory(data, id) {
    return ApiService.fetchData({
        url: `${categoriesEndpoint}/${id}`,
        method: 'patch',
        data,
    })
}

export async function apiDeleteTreatmentCategory(id) {
    return ApiService.fetchData({
        url: `${categoriesEndpoint}/${id}`,
        method: 'delete',
    })
}
